module.exports = __webpack_public_path__ + "static/media/NSS.0b72782a.jpg";